// extracted by mini-css-extract-plugin
export default {"wrapper":"hVK7SvaJqIdhi7hHLPjn","icon":"mNSnVwq9XZ9UDDcUdKA8","fadeIn":"BnpJEmvFJm5cOKrvJ_Vo","ratio":"PwfGnB1iQzZRsLkDvClU"};